module.exports = __webpack_public_path__ + "img/yuedu.97d9d4ec.png";